<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import BaseSettingsHeader from '../../components/BaseSettingsHeader.vue';
import SettingsLayout from '../../SettingsLayout.vue';
import CheckoutConfig from './CheckoutConfig.vue';
import BasePaywallModal from '../../components/BasePaywallModal.vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const { t } = useI18n();
const router = useRouter();
const { isCloudFeatureEnabled, isOnChatwootCloud, accountId } = useAccount();
const paywallI18nKey = computed(() =>
  isOnChatwootCloud.value ? 'PAYWALL' : 'ENTERPRISE_PAYWALL'
);
const isCartEnabled = computed(() => isCloudFeatureEnabled(FEATURE_FLAGS.CART));

const openBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <template v-if="!isCartEnabled">
    <div
      class="flex w-full items-center justify-center min-h-[calc(100vh-8rem)] px-6 py-12"
    >
      <BasePaywallModal
        feature-prefix="CHECKOUT_SETTINGS"
        :i18n-key="paywallI18nKey"
        :is-on-chatwoot-cloud="isOnChatwootCloud"
        @upgrade="openBilling"
      />
    </div>
  </template>
  <template v-else>
    <SettingsLayout :no-records-found="false" class="gap-10">
      <template #header>
        <BaseSettingsHeader
          :title="t('CHECKOUT_SETTINGS.SETTINGS.TITLE')"
          :description="t('CHECKOUT_SETTINGS.SETTINGS.DESCRIPTION')"
          feature-name="checkout"
        />
      </template>
      <template #body>
        <div class="flex flex-col gap-6 mt-4">
          <CheckoutConfig />
        </div>
      </template>
    </SettingsLayout>
  </template>
</template>
